// extracted by mini-css-extract-plugin
export default {"paginatorBtn":"pagination_paginatorBtn__kjXnC","disabled":"pagination_disabled__Raek8","tableAction":"pagination_tableAction__qp01L","tableSort":"pagination_tableSort__pBUvS"};